import classnames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import { isEmpty } from 'lodash';
import T from 'prop-types';
import React from 'react';

import styles from './ManagementWrapper.module.scss';

const cx = classnames.bind(styles);

const ManagementWrapper = ({ breadcrumbs = {}, className, children }) => (
  <div className={cx('container', 'mgh-auto', 'mgt-80', className)}>
    {!isEmpty(breadcrumbs) && <Breadcrumbs className={cx('breadcrumbs')} crumbs={breadcrumbs} />}
    <div className={cx('content-wrapper')}>{children}</div>
  </div>
);

ManagementWrapper.propTypes = {
  breadcrumbs: T.object,
  children: T.oneOfType([T.func, T.string, T.node]),
  className: T.string,
};

export default ManagementWrapper;
